var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSuccessPopup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.775,
    height: 11.776,
    viewBox: "0 0 11.775 11.776",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6154",
    "data-name": "Group 6154",
    transform: "translate(1.061 1.061)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_232",
    "data-name": "Line 232",
    x2: 9.655,
    y2: 9.655,
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_233",
    "data-name": "Line 233",
    x2: 9.655,
    y2: 9.655,
    transform: "translate(9.655) rotate(90)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSuccessPopup);
export default __webpack_public_path__ + "static/media/Close_SuccessPopup.80cb295994d17022fa80d339feec973f.svg";
export { ForwardRef as ReactComponent };